// Global Functions
window.isBase64Simple = (str) => {
    if(typeof str !== 'string' || str.trim() === '') {
        return false;
    }
    
    const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    
    return base64Regex.test(str);
};

window.isBase64 = (str) => {
    if((typeof str === 'string') || (str instanceof String)) {
        if((str == "") || (str.trim() == "")) {
            return false;
        }

        try {
            return (btoa(atob(str)) == str);
        } catch (err) {
            return false;
        }
    } else {
        return false;
    }
};

window.b64EncodeUnicode = (texto) => {
    return btoa(unescape(encodeURIComponent(texto)));
};

window.normalizeBase64 = (value) => {
    if((typeof value !== "string") && !(value instanceof String)) {
        return null;
    }

    let normalized = String(value).trim();

    if(!normalized) {
        return null;
    }

    normalized = normalized.replace(/^data:[^;,]+;base64,/i, "");
    normalized = normalized.replace(/\s+/g, "");
    normalized = normalized.replace(/-/g, "+").replace(/_/g, "/");

    if(normalized.length % 4 === 1) {
        return null;
    }

    normalized += "=".repeat((4 - normalized.length % 4) % 4);

    if(!/^[A-Za-z0-9+/]*={0,2}$/.test(normalized)) {
        return null;
    }

    return normalized;
};

window.b64DecodeUnicode = (texto) => {
    let textoNormalizado = window.normalizeBase64(texto);

    if(textoNormalizado) {
        if((window.isBase64Simple(textoNormalizado)) || (window.isBase64(textoNormalizado))) {
            try {
                return decodeURIComponent(atob(textoNormalizado).split("").map((c) => {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(""));
            } catch (error) {
                try {
                    return atob(textoNormalizado);
                } catch (error) {
                    return "";
                }
            }
        } else {
            return "";
        }
    } else {
        return "";
    }
};

window.validateEmail = (email) => {
    return String(email).toLowerCase().match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

window.clonarItem = (item) => {
    return JSON.parse(JSON.stringify(item));
};

import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import VueSocketIO from "vue-3-socket.io";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import Maska from "maska";

import VueSignaturePad from "vue-signature-pad";

import VueConfetti from "vue-confetti";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import CKEditor from "@mayasabha/ckeditor4-vue3";

import "animate.css";

import VCalendar from "v-calendar";
import "v-calendar/style.css";

import { v4 as uuidv4 } from "uuid";

import mitt from "mitt";
const emitter = mitt();

import ptBR from "./locales/ptBR.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import "./registerServiceWorker";

const i18n = createI18n({
    locale: "ptBR", 
    fallbackLocale: "ptBR", 
    messages: { ptBR, en, es }
});

const checkoutPublico = /^\/pagar\//.test(window.location.pathname);
var url = checkoutPublico ? window.location.origin : window.location.href;

var token = /token=([^&]+)/.exec(url);
if(token) {
    token = token[1];
}

var sistema = /sistema=([^&]+)/.exec(url);
if(sistema) {
    sistema = sistema[1];
}

if(token) {
    JwtService.saveToken(token);
} else {
    token = JwtService.getToken();
}

if(sistema) {
    JwtService.saveSistema(sistema);
} else {
    sistema = JwtService.getSistema();

    if(!sistema && !checkoutPublico) {
        sistema = "CLINIC";
        JwtService.saveSistema(sistema);
    }
}

router.beforeEach((to, from, next) => {
    if(to.meta.requiresAuth) {
        const token = JwtService.getToken();

        if(token) {
            next();
        } else {
            window.location.href = "https://auth.micrologos.com.br/#/login/" + sistema;
        }
    } else {
        next();
    }
});

const deviceName = JwtService.criarObterGenerico("deviceName", "DEVICE_" + uuidv4());

const app = createApp(App);
app.use(i18n);

ApiService.init();

if (!checkoutPublico) app.use(new VueSocketIO({
    withCredentials: true, 
    reconnection: true, 
    debug: true, 
    // connection: "https://backendio.clinicspirit.com", 
    connection: "https://backendio.micrologos.com.br", 
    // connection: "http://localhost:3000", 
    vuex: {
        store, 
        actionPrefix: "SOCKET_", 
        mutationPrefix: "SOCKET_"
    }, 
    options: {
        query: {
            token, 
            deviceName
        }
    }
}));

app.use(router);
app.use(store);
app.use(VueSweetalert2);
app.use(Maska);
app.use(VueSignaturePad);
app.use(VueConfetti);
app.use(Toast, {});
app.use(CKEditor);
app.use(VCalendar, {});
app.config.globalProperties.emitter = emitter;

app.mount("#app");